
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useIsMobile } from '../hooks/use-mobile';
import MobileBottomNav from './MobileBottomNav';
import RenterBottomNav from './RenterBottomNav';
import OnboardingFlow from './OnboardingFlow';
import { isRenter } from '../utils/roleHelpers';
import { logger } from '../services/productionLogger';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, profile } = useAuth();
  const isMobile = useIsMobile();
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Debug logging
  useEffect(() => {
    if (import.meta.env.DEV) {
      logger.debug('[Navigation] State', {
        user: !!user,
        profile: !!profile,
        roles: profile?.roles,
        isMobile,
        pathname: location.pathname
      });
    }
  }, [user, profile, isMobile, location.pathname]);

  useEffect(() => {
    // Only show onboarding for renters who just signed up (not existing users logging in)
    if (user && profile && isRenter(profile)) {
      const isNewSignup = localStorage.getItem('isNewSignup') === 'true';
      const hasCompletedOnboarding = localStorage.getItem('onboardingComplete');
      
      if (isNewSignup && !hasCompletedOnboarding) {
        setShowOnboarding(true);
      }

      // Clear the new signup flag after checking
      localStorage.removeItem('isNewSignup');
    }
  }, [user, profile]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    localStorage.setItem('onboardingComplete', 'true');
  };

  // Don't show navigation on certain pages
  const hideNavRoutes = ['/login', '/signup', '/'];
  if (hideNavRoutes.includes(location.pathname)) {
    return null;
  }

  // Show onboarding if needed
  if (showOnboarding) {
    return <OnboardingFlow onComplete={handleOnboardingComplete} />;
  }

  // Show mobile navigation for authenticated users on mobile
  if (isMobile && user && profile) {
    // Use RenterBottomNav for renters, MobileBottomNav for landlords
    if (isRenter(profile)) {
      return <RenterBottomNav />;
    } else {
      return <MobileBottomNav />;
    }
  }

  // Desktop navigation for authenticated users
  if (!isMobile && user && profile) {
    return (
      <nav className="bg-gradient-to-b from-slate-900/95 via-slate-900/90 to-slate-900/70 backdrop-blur-xl border-b border-white/10 sticky top-0 z-40">
        {/* Desktop nav content would go here */}
      </nav>
    );
  }

  // No navigation for non-authenticated users
  return null;
};

export default Navigation;
